import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'pray', 'Pray', [["path",{"d":"M11 5a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"}],["path",{"d":"M7 20h8l-4 -4v-7l4 3l2 -2"}]]);